import { request } from '@/utils/request';

//查询列表
export function postApprovalList(data: any) {
  return request({
    url: '/data/approval/list',
    method: 'post',
    data,
  });
}

export function getApprovalOptions() {
  return request({
    url: '/data/approval/options',
    method: 'get',
  });
}

export function getApprovalOptionsDbo() {
  return request({
    url: '/data/approval/options/dbo',
    method: 'get',
  });
}

export function getApprovalapprove(data: any) {
  return request({
    url: '/data/approval/approve',
    method: 'post',
    data,
    timeout: 60 * 1000,
  });
}

export function getApprovaldecline(data: any) {
  return request({
    url: '/data/approval/decline',
    method: 'post',
    data,
  });
}

export function getApprovalwithdraw(data: any) {
  return request({
    url: '/data/approval/withdraw',
    method: 'post',
    data,
  });
}
export function getApprovaldetail(data: any) {
  return request({
    url: '/data/approval/detail',
    method: 'post',
    data,
  });
}

// notice
export function getNotice() {
  return request({
    url: '/approval/getNotice',
    method: 'get',
  });
}
export function readOneNotice(data: any) {
  return request({
    url: '/approval/readOneNotice',
    method: 'get',
    params: data,
  });
}
export function readAllNotice() {
  return request({
    url: '/approval/readAllNotice',
    method: 'get',
  });
}

export function getKpiBasicInfo(data: any) {
  return request({
    url: `/kpi/definition/basic/detail/${data}`,
    method: 'get',
  });
}
export function getKpiExtendedInfo(data: any) {
  return request({
    url: `/kpi/definition/extended/detail/${data}`,
    method: 'get',
  });
}
export function fetchAlertApproval(params: any) {
  return request({
    url: `/data/approval/alertApprovals`,
    method: 'get',
    params,
  });
}
export function fetchAlertApprovalList(params: any) {
  return request({
    url: `/data/approval/alertApprovalsList`,
    method: 'get',
    params,
  });
}

export function fetchMasterApprovalList(approvalId: any) {
  return request({
    url: `/data/approval/getApprovalDetail/${approvalId}`,
    method: 'get',
  });
}

export function getReferenceDetail(id: number) {
  return request({
    url: `kpi/dimension/detail/${id}`,
    method: 'get',
  });
}

export function batchApproval(data: any) {
  return request({
    url: `/data/approval/batch/approval`,
    method: 'post',
    data,
  });
}

// judge if this data has released version
export function judgeApproval(data: any) {
  return request({
    url: `/data/approval/submitByChannel/judge`,
    method: 'post',
    data,
  });
}

export function getApprovalDetail(id: number) {
  return request({
    url: `data/approval/getApprovalDetail/${id}`,
    method: 'get',
  });
}
export function getBusinessObjectApprovalDetail(id: number) {
  return request({
    url: `/dataResourceCatalog/businessObject/approval/detail?id=${id}`,
    method: 'get',
  });
}
